module.exports = __webpack_public_path__ + "media/images/admin/icons/battery-c94f6b75caf2b02d5f23ba9d94631bc5.svg";